if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}





class StickyATCBar extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.getAttribute('section-id');
    this.productId = this.getAttribute('product-id');
    this.productTitle = this.getAttribute('product-title');
    this.productUrl = this.getAttribute('product-url');
    this.hasMultipleVariants = this.getAttribute('has-multiple-variants') === 'true';
    this.variantId = this.getAttribute('variant-id');
    this.featuredImage = this.getAttribute('featured-image');
    this.buttonHref = this.getAttribute('button-href');

    this.cacheElements();
    this.attachEvents();
    this.updateContent();
    this.onScroll();
  }

  cacheElements() {
    this.bar = this;
    this.img = this.querySelector('.sticky-atc-bar__img');
    this.title = this.querySelector('.sticky-atc-bar__title');
    this.price = this.querySelector('.sticky-atc-bar__price');
    this.button = this.querySelector('.sticky-atc-bar__button');
    this.productSection = document.querySelector('product-info');
    this.productSectionAddToCart = document.querySelector('.product .product-form__buttons');
  }

  attachEvents() {
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

 isInViewport(el) {
    
    let top = el.offsetTop;
  let left = el.offsetLeft;
  let width = el.offsetWidth;
  let height = el.offsetHeight;

  while(el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
  );

}

  onScroll() {
    if (!this.productSectionAddToCart) return;
    const isInView = this.isInViewport(this.productSectionAddToCart);

    this.bar.style.display = isInView ? 'none' : 'block';

    if (!isInView) this.updateContent();
  }

  updateContent() {
    if (!this.productSection) return;

    // Update image
    const productImg = this.productSection.querySelector('.product__media img');
    if (productImg && this.img) {
      this.img.src = productImg.currentSrc || productImg.src;
      this.img.alt = productImg.alt || this.productTitle;
    }

    // Update price
    const priceEl = this.productSection.querySelector('.price-item--regular');
    if (priceEl && this.price) {
      this.price.textContent = priceEl.textContent.trim();
    }

    // Update button
    if (this.button) {
   // Prevent default href navigation
    this.button.removeAttribute('href');

    // Add click event to scroll to the target ID
    this.button.onclick = (e) => {
      debugger;
      e.preventDefault();
      const targetEl = this.productSectionAddToCart;
      if (targetEl) {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

      if (this.hasMultipleVariants) {
        this.button.textContent = 'Select Options';
      } else {
        const mainButtonText = this.productSection.querySelector('.product-form__submit span');
        if (mainButtonText) {
          this.button.textContent = mainButtonText.textContent.trim();
        }
      }
    }

  }
}

customElements.define('sticky-atc-bar', StickyATCBar);
